<app-sales-credit-number [creditNumber]="data().number" [data]="data()" *ngIf="categoryCode !== 'kredicash' "></app-sales-credit-number>

<!--PRODUCTOS FITRADOS-->
<ng-container *ngIf="internalStep === Options.products">
  <div class="container section__productItems h-full">
    <div class="wrapper">
      <div class="sectionContainer fadeinright animation-duration-200">
        <article class="align__top big__padBot">
          <div class="mainInfo mainInfo--full">
            <h1>
              Elige el producto que más te guste
            </h1>
          </div>

          <div class="productList pt-25">
            <!-- SELECCIÓN PREVIA -->
            <!-- <div class="prevSelection mb-40">
              <p-accordion class="w-full" expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
                <p-accordionTab iconPos="end">
                  <ng-template pTemplate="header">
                    <div class="prevSelection__header">
                      <div class="info">
                        <i class="pi pi-list"></i>
                        <h2>Tu selección previa</h2>
                      </div>

                      <div class="arrow">
                        <i class="pi pi-chevron-down"></i>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <div class="productListSelection carouselSelection">
                      <div class="productListSelection__container">
                        <div class="productListSelection__item">
                          <div class="productListSelection__itemCont">
                            <div class="item item__icon">
                              <img [src]="onReturnCategoryIconAndName().icon_url" [alt]="onReturnCategoryIconAndName().name">
                            </div>
                          </div>
                        </div>
                        <div class="productListSelection__item carouselItem">
                          <div class="productListSelection__itemCont">
                            <div class="productListSelection__carousel">
                              <p-carousel [value]="selectedBrands" [numVisible]="1" [numScroll]="1" [autoplayInterval]="3000" [circular]="false">
                                <ng-template let-brand pTemplate="item">
                                  <div class="productListSelection__carouselItem">
                                    <img *ngIf="brand.image_url; else showSelectedBrandName" [src]="brand.image_url" [alt]="brand.name"/>

                                    <ng-template #showSelectedBrandName>
                                      <p>{{ brand.name }}</p>
                                    </ng-template>
                                  </div>
                                </ng-template>
                              </p-carousel>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="productListSelection__amount">
                      <p>Monto máximo de la cuota: <span>{{selectedAmount | currency}}</span></p>
                    </div>
                  </ng-template>
                </p-accordionTab>
              </p-accordion>
            </div> -->

            <!-- FILTROS -->
            <div class="filtersList">
              <div class="filtersList__item">
                <p-accordion class="w-full" expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">

                  <!-- FILTRO MARCAS -->
                  <p-accordionTab #brandsTab class="filtersList__brands" iconPos="end" [(selected)]="brandsTabOpen">
                    <ng-template pTemplate="header">
                      <div class="accordion__header">
                        <div class="info">
                          <i class="pi pi-tag"></i>
                          <h2>Marcas</h2>
                        </div>

                        <div class="action">
                          <div class="amountProductRef" *ngIf="selectedBrands.length > 0">
                            <span>{{selectedBrands.length}} seleccionados</span>
                          </div>

                          <div class="arrow">
                            <i class="pi pi-chevron-down"></i>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <div class="accordion__content">
                        <div class="accordion__contentTitle mb-20">
                          <h3>Filtros por marcas:</h3>

                          <div class="form__checkbox">
                            <div class="form__checkboxItem">
                              <p-checkbox [binary]="true" inputId="allBrands" [ngModel]="selectedBrands.length === brandsFiltered.length" (onChange)="onToggleAllBrands()" />
                              <label for="allBrands">{{ selectedBrands.length === brandsFiltered.length ? 'Desmarcar todas' : 'Seleccionar todas' }}</label>
                            </div>
                          </div>
                        </div>

                        <div class="accordion__contentItems pb-25">
                          <div class="form__checkbox">
                            <div class="form__checkboxItem" *ngFor="let brand of brandsFiltered">
                              <p-checkbox [(ngModel)]="selectedBrands" name="group" [value]="brand" [inputId]="brand.id" (onChange)="onApplyFilter()" />
                              <label [for]="brand.id">{{ brand.name }}</label>
                            </div>
                          </div>
                        </div>

                        <div class="accordion__contentBtn">
                          <button pButton pRipple label="Aplicar filtros" icon="pi pi-sliders-h" iconPos="right" class="p-button-secondary p-button-raised p-button-rounded w-full n-shadow" (click)="brandsTabOpen = false"></button>
                        </div>
                      </div>
                    </ng-template>
                  </p-accordionTab>

                  <!-- FILTRO ABONO -->
                  <p-accordionTab #abonoTab class="filtersList__percent" iconPos="end" [(selected)]="abonoTabOpen">
                    <ng-template pTemplate="header">
                      <div class="accordion__header">
                        <div class="info">
                          <i class="pi pi-wallet"></i>
                          <h2>Abono</h2>
                        </div>

                        <div class="action">
                          <div class="amountProductRef" *ngIf="selectedPercentages && selectedPercentages.length > 0">
                            <span>{{selectedPercentages.length}} seleccionados</span>
                          </div>

                          <div class="arrow">
                            <i class="pi pi-chevron-down"></i>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <div class="accordion__content">
                        <div class="accordion__contentTitle mb-20">
                          <h3>Filtros por abono:</h3>

                          <div class="form__checkbox">
                            <div class="form__checkboxItem">
                              <p-checkbox [binary]="true" inputId="allPercentages" [ngModel]="selectedPercentages.length === percentages.length" (onChange)="onToggleAllPercentages()" />
                              <label for="allPercentages">{{ selectedPercentages.length === percentages.length ? 'Desmarcar todos' : 'Seleccionar todos' }}</label>
                            </div>
                          </div>
                        </div>

                        <div class="accordion__contentItems pb-25">
                          <div class="form__checkbox form__checkbox--3cols">
                            <div class="form__checkboxItem" *ngFor="let percent of percentages">
                              <p-checkbox [(ngModel)]="selectedPercentages" name="percentGroup" [value]="percent.value" [inputId]="'percent-' + percent.value" (onChange)="onApplyFilter()"></p-checkbox>
                              <label [for]="'percent-' + percent.value">{{ percent.label }}</label>
                            </div>
                          </div>
                        </div>

                        <div class="accordion__contentBtn">
                          <button pButton pRipple label="Aplicar filtros" icon="pi pi-sliders-h" iconPos="right" class="p-button-secondary p-button-raised p-button-rounded w-full n-shadow" (click)="abonoTabOpen = false"></button>
                        </div>
                      </div>
                    </ng-template>
                  </p-accordionTab>
                </p-accordion>
              </div>
            </div>

            <!-- LISTADO DE PRODUCTOS -->
            <div class="productListBox">
              <p-table #dt2 [value]="filteredFinalProducts" dataKey="id" [rows]="5" [paginator]="true" [loading]="loading" [tableStyle]="{ 'min-width': '100%' }">

                <ng-template pTemplate="caption">
                  <div class="searchBox searchBox--iconLeft">
                    <div class="searchBox__input">
                      <i class="pi pi-search"></i>
                      <input pInputText type="text" [(ngModel)]="searchText" (input)="onApplyFilter()" placeholder="Buscar por nombre..." />
                    </div>
                  </div>


                  <div class="productListFilters pt-20">
                    <div class="productListFilters__category">
                      <div class="amountProductRef">
                        <p class="blue">Categoria:</p>
                        <span>{{ onReturnCategoryIconAndName().name }}</span>
                      </div>
                    </div>

                    <div class="productListFilters__quantity">
                      <p><strong>{{ displayedProductCount }}</strong> {{ displayedProductCount === 1 ? ' producto' : ' productos' }}</p>
                    </div>

                    <!-- <div class="productListFilters__btn">
                      <p-button label="Filtro" [text]="true" icon="pi pi-filter" (onClick)="openModalFiltered()"/>
                    </div> -->
                  </div>
                </ng-template>

                <ng-template pTemplate="body" let-product>
                  <tr>
                    <td>
                      <div class="productListItem" (click)="openModalProductSummary(product)">
                        <div class="productListItem__cont">
                          <div class="img">
                            <img [src]="onReturnProductIcon(product)" [alt]=" 'name' ">
                          </div>
                          <div class="info">
                            <div class="title">
                              <h3>{{ product.name }}</h3>
                            </div>
                            <div class="value">
                              <div class="valueText">
                                <h4>Abono desde:</h4>
                                <div class="valueText__number">
                                  <span class="highlight">{{ onCalculateFromInstallment(product.quotes) | currency }}</span>
                                  <span class="percent">{{ product.quotes[0]?.installment?.min }}%</span>
                                </div>
                              </div>
                              <div class="valueText">
                                <h4>Cuota desde:</h4>
                                <div class="valueText__number">
                                  <span class="highlight">{{ onCalculateFromQuota(product.quotes) | currency }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td>
                      <div class="productListItem__empty">
                        <p>No se han encontrado resultados.</p>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>

  <!--MODAL RESUMEN DEL PRODUCTO -->
  <p-dialog [(visible)]="showModalProductSummary" [modal]="true" [draggable]="false" [resizable]="false" position="bottom" (onHide)="onModalProductSummaryHide()">
    <div class="dialog">
      <div class="container">
        <div class="wrapper">
          <div class="dialog__form noPadTop">
            <div class="pricingBox">
              <div class="pricingBox__data mb-15">
                <div class="pricingBox__icon">
                  <img [src]="product().category?.icon_url" [alt]=" product().category?.name ">
                </div>

                <div class="pricingBox__title">
                  <span>Producto seleccionado:</span>
                  <h3>{{product().name}}</h3>
                </div>
              </div>

              <div class="pricingBox__price mb-10" *ngIf="!macroFlowService.isExperanzaFlow(flowCode)">
                <p>
                  <span>Precio:</span>
                </p>

                <div class="pricingBox__editor">
                  <div class="input">
                    <p-inputNumber id="productPriceInput" [(ngModel)]="priceInputValue" mode="currency" [currency]="country.currency" [locale]="country.locale" [readonly]="!isEditingPrice" [disabled]="!isEditingPrice"></p-inputNumber>

                    <div class="btn" *ngIf="canEditPrice()">
                      <div class="label-mode" *ngIf="!isEditingPrice">
                        <button class="edit" type="button" (click)="startEditPrice()" aria-label="Editar precio">
                          <i>
                            <app-edit-price-icon></app-edit-price-icon>
                          </i>
                        </button>
                      </div>

                      <div class="edit-mode" *ngIf="isEditingPrice">
                        <button class="accept" type="button" (click)="finishEditPrice()" aria-label="Confirmar precio">
                          <i>
                            <app-confirm-price-icon></app-confirm-price-icon>
                          </i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="error-msg" *ngIf="showMsgErrorLimit">
                    <i class="pi pi-exclamation-circle"></i>
                    <p>{{ msgErrorLimit }}</p>
                  </div>
                </div>
              </div>

              <div class="pricingBox__actions" [class.disabled]="isEditingPrice">
                <div class="pricingBox__additionalProduct mb-20" *ngIf="hasAdditionalProducts">
                 <p-accordion [(activeIndex)]="activeAccordionIndex" [multiple]="false" [styleClass]="additionalProductAdded ? 'product-added' : ''" (onClose)="onAccordionClose()">
                    <p-accordionTab>
                      <!-- HEADER -->
                      <ng-template pTemplate="header">
                        <div class="additionalProduct__header">
                          <!-- Mensaje inicial -->
                          <div class="additionalProduct__headerMsg fadein animation-duration-400" *ngIf="!additionalProductAdded">
                            <div class="msg">
                              <h4>¿Quieres incluir algun plan?</h4>
                              <p>Añade un producto adicional a tu financiamiento.</p>
                            </div>
                            <div class="icon">
                              <app-circle-plus-icon></app-circle-plus-icon>
                            </div>
                          </div>

                          <!-- Producto seleccionado -->
                          <div class="additionalProduct__headerSelected fadein animation-duration-400" *ngIf="additionalProductAdded">
                            <div class="info">
                              <div class="title">
                                <h4>Producto adicional seleccionado:</h4>
                              </div>
                              <div class="actions">
                                <button type="button" (click)="editAdditionalProduct($event)">
                                  <i class="pi pi-pencil"></i>
                                </button>
                                <button type="button" (click)="removeAdditionalProduct($event)">
                                  <i class="pi pi-trash"></i>
                                </button>
                              </div>
                            </div>

                            <div class="product">
                              <div class="label">
                                <i>
                              <app-circle-full-plus-icon></app-circle-full-plus-icon>
                            </i>
                            <span>{{ selectionAdditionalProduct?.name }}</span>
                          </div>
                          <div class="value">
                            <span>{{ getAdditionalProductNetAmount() | currency }}</span>
                          </div>
                        </div>
                      </div>
                        </div>
                      </ng-template>

                      <!-- CONTENT -->
                      <ng-template pTemplate="content">
                        <div class="additionalProduct__content">
                          <div class="additionalProduct__contentBlock">
                            <!-- Título -->
                            <div class="additionalProduct__contentTitle">
                              <h4>Selecciona un producto adicional:</h4>
                            </div>

                            <!-- Selector -->
                            <div class="additionalProduct__contentSelector">
                              <div class="form__radio">
                                <div class="form__radioItem" *ngFor="let additionalProduct of additionalProducts; let i = index">
                                  <p-radioButton
                                    [inputId]="'additionalProduct' + i"
                                    name="additionalProducts"
                                    [value]="additionalProduct"
                                    [(ngModel)]="selectionAdditionalProduct"
                                    [disabled]="loading || loadingQuotes">
                                  </p-radioButton>
                                  <label [for]="'additionalProduct' + i">
                                    <div class="text">
                                      <span>{{ additionalProduct.name }}</span>
                                      <small>Monto: <strong>{{ additionalProduct.amount | currency }}</strong> &bull; Descuento: <strong>{{ additionalProduct.discount_pct }}%</strong></small>
                                    </div>
                                    <span class="value">{{ onCalculateAdditionalProductNetAmount(additionalProduct) | currency }}</span>
                                  </label>
                                </div>
                              </div>
                            </div>

                            <!-- Botones -->
                            <div class="additionalProduct__contentButtons">
                              <div class="btn" *ngIf="showCancelButton">
                                <p-button label="Cancelar" [text]="true" [plain]="true" (click)="cancelEditionAdditionalProduct()"></p-button>
                              </div>

                              <div class="btn">
                                <button pButton pRipple [label]="showAdditionalProductAdded ? 'Cambiar' : 'Agregar producto'" (click)="addAdditionalProduct()" [loading]="loadingQuotes" [disabled]="!selectionAdditionalProduct || loading || loadingQuotes" class="p-button-secondary p-button-raised p-button-rounded n-shadow w-full"></button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </p-accordionTab>
                  </p-accordion>
                </div>

                <div class="pricingBox__form pt-10 mb-20">
                  <div class="pricingBox__subtitle mb-10">
                    <h4>Abono:</h4>
                  </div>
                  <div class="pricingBox__formCont">
                    <div class="pricingBox__formItem percentage">
                      <div class="info">
                        <p-dropdown (onChange)="onPercentageChange()" [options]="percentagesOnProduct" [(ngModel)]="selectedPercentagesOnProduct" optionLabel="label" optionValue="value" [disabled]="loading || loadingQuotes"/>
                      </div>
                    </div>
                    <div class="pricingBox__formSeparator">
                      <div class="line">
                        <span class="circle"></span>
                        <span class="rect"></span>
                        <span class="circle"></span>
                      </div>
                    </div>
                    <div class="pricingBox__formItem value">
                      <div class="info">
                        <p>{{ onCalculateAmount(false) | currency }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="pricingBox__financed mb-20" *ngIf="!macroFlowService.isExperanzaFlow(flowCode)">
                  <div class="pricingBox__financedTitle">
                    <i>
                      <app-money-white-icon></app-money-white-icon>
                    </i>
                    <h4>Monto financiado:</h4>
                  </div>
                  <div class="pricingBox__financedValue">
                    <p><strong>{{ onCalculateFinancedAmount() | currency }}</strong></p>
                  </div>
                </div>

                <div class="pricingBox__financed mb-20">
                  <div class="pricingBox__financedTitle">
                    <i>
                      <app-money-white-icon></app-money-white-icon>
                    </i>
                    <h4>Monto financiado:</h4>
                  </div>
                  <div class="pricingBox__financedValue">
                    <p><strong>{{ onCalculateFinancedAmount() | currency }}</strong></p>
                  </div>
                </div>

                <div class="pricingBox__frequency mb-20" *ngIf="frequency.length > 1">
                  <div class="pricingBox__subtitle mb-10">
                    <h4>Frecuencia de pago:</h4>
                  </div>

                  <div class="pricingBox__frequencyBtns">
                    <p-selectButton
                    [options]="frequency"
                    [(ngModel)]="frequencySelected"
                    optionLabel="label"
                    optionValue="value"
                    [allowEmpty]="false"
                    [disabled]="loading || loadingQuotes"
                    (onChange)="onPercentageChange()" />
                  </div>
                </div>

                <div class="pricingBox__selector">
                  <div class="pricingBox__subtitle mb-10">
                    <h4>Opciones de plazo:</h4>
                  </div>
                  <div class="pricingBox__selectorCont">
                    <div class="radioSelectionBox radioSelectionBox--smallP">
                      <div *ngIf="showRadioSelectionBox && !loadingQuotes">
                        <div class="radioSelectionBox__item" *ngFor="let p of product().quotes let i = index">
                          <label pRipple class="radioButtonBox" [for]="'quote' + i">
                            <p-radioButton name="quotes" [value]="p" [(ngModel)]="selectedQuote" [inputId]="'quote' + i" [disabled]="loading || loadingQuotes" />
                            <span class="radioButtonBox__text" *ngIf="!macroFlowService.isExperanzaFlow(flowCode)">En <strong>{{ p.quota.quantity }} cuotas</strong> y pagaré <span class="highlight">{{ p.quota.from | currency }}</span></span>
                            <span class="radioButtonBox__text" *ngIf="macroFlowService.isExperanzaFlow(flowCode)">En <strong>{{ p.quota.quantity }} cuotas</strong> y pagaré <span class="highlight">{{ p.quota.from | currency }}</span>. Total: {{ p.quota.quantity * p.quota.from | currency}} (IGV incluido)</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="pricingBox__loading" *ngIf="loadingQuotes">
                  <div class="loading-indicator">
                    <p-progressSpinner></p-progressSpinner>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dialog__btn pt-30">
            <button pButton pRipple label="Continuar" (click)="saveCalculateNewPaymentInstallment()" [loading]="loading"  [disabled]="!selectedQuote"  class="p-button-primary p-button-raised p-button-rounded w-full"></button>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>

  <!--MODAL DE FILTROS-->
  <p-sidebar [(visible)]="showModalFilter" position="right" [blockScroll]="true">
    <div class="sidebar">
      <div class="container">
        <div class="wrapper">
          <div class="sidebar__cont">
            <div class="sidebar__info">
              <h2>Filtros</h2>
            </div>

            <div class="sidebar__filters">
              <!-- ORDEN -->
              <div class="filter__item filter__item--row">
                <div class="filter__title">
                  <h4>Orden</h4>
                </div>
                <div class="filter__form">
                  <p-dropdown [options]="orderByOptions" [(ngModel)]="selectedOrder" placeholder="Ordenar por" (onChange)="orderBy()"></p-dropdown>
                </div>
              </div>

              <!-- CATEGORIA -->
              <div class="filter__item">
                <div class="filter__title">
                  <h4>Categoría</h4>
                  <div *ngIf="flowCode===autogestionCliente" class="action">
                    <div class="action__btn" (click)="onGoToCategoryList()">
                      <div class="icon">
                        <app-cross-arrows-icon></app-cross-arrows-icon>
                      </div>
                      <div class="text">
                        <p>Cambiar</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="filter__form">
                  <div class="categoryBlock">
                    <div class="img">
                      <img [src]="onReturnCategoryIconAndName().icon_url" [alt]=" onReturnCategoryIconAndName().name ">
                    </div>
                    <div class="text">

                     <p>{{ onReturnCategoryIconAndName().name }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- MARCA -->
              <div class="filter__item">
                <div class="filter__title">
                  <h4>Marcas</h4>
                </div>
                <div class="filter__form">
                  <div class="form__checkbox">
                    <div class="form__checkboxItem" *ngFor="let brand of brandsFiltered, let i = index;">
                      <p-checkbox [(ngModel)]="selectedBrands" name="group" [value]="brand" [inputId]="brand.id" (onChange)="onApplyFilter()" />
                      <label [for]="brand.id">{{ brand.name }}</label>
                    </div>
                  </div>
                </div>
              </div>

             <!--  PORCENTAJE DE ABONO
              <div class="filter__item">
                <div class="filter__title">
                  <h4>Porcentaje de abono</h4>
                </div>
                <div class="filter__form">
                  <div class="form__checkbox">
                    <div class="form__checkboxItem" *ngFor="let percent of percentages">
                      <p-checkbox [(ngModel)]="selectedPercentages" name="group" [label]="percent.label" [value]="percent.value" (onChange)="onApplyFilter()" />
                    </div>
                  </div>
                </div>
              </div>-->

              <!-- MONTO DE LA CUOTA -->
              <div class="filter__item">
                <div class="filter__title">
                  <h4>Máximo monto de la cuota</h4>
                </div>
                <div class="filter__form">
                  <div class="p-float-label">
                    <p-inputNumber mode="decimal" [prefix]="country.currency" [locale]="country.locale" [minFractionDigits]="2" [maxFractionDigits]="2" [min]="0" [(ngModel)]="selectedAmount" (ngModelChange)="onApplyFilter()"></p-inputNumber>
                    <label>Monto</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sidebar__footer">
      <button pButton pRipple [label]="'Mostrar ' + filteredFinalProducts.length + ' ' + (filteredFinalProducts.length === 1 ? ' producto' : ' productos')" [disabled]="filteredFinalProducts.length <= 0" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="showModalFilter = false"></button>
    </div>
  </p-sidebar>
</ng-container>

<!--MODAL MENSAJE INICIAL-->
<p-dialog [(visible)]="showModalMsg" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Importante</h2>
          <p>El pago inicial requerido depende de varios factores que incluyen la <strong>información del cliente</strong> y el <strong>producto seleccionado</strong>.</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Continuar" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="showModalMsg=false"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<app-sales-navigation-bar [activeStep]="internalStep" [visitedSteps]="visitedSteps" (gotoStepEvent)="onGotoStep($event)" (gotoStepEventNavigator)="onGotoStepNavigator($event)"/>
